import { ForkEffect } from 'redux-saga/effects';

import countriesSaga from './countries/sagas';
import subdivisionsSaga from './subdivisions/sagas';

export default (): Array<Generator<ForkEffect<never>, void, unknown>> => {
  return [countriesSaga(), subdivisionsSaga()];
};
